/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_FloorsInputs */

const en_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Floors`)
};

const es_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de pisos`)
};

const fr_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre d'étages`)
};

const de_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etagen gesamt`)
};

const ja_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総階数`)
};

const zh_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总楼层数`)
};

const ar_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي الطوابق`)
};

const id_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Lantai`)
};

const it_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piani Totali`)
};

const ru_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего этажей`)
};

const pt_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de Andares`)
};

const ko_field_floors = /** @type {(inputs: Field_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 층수`)
};

/**
* | output |
* | --- |
* | "Total Floors" |
*
* @param {Field_FloorsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_floors = /** @type {((inputs?: Field_FloorsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_FloorsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_floors(inputs)
	if (locale === "es") return es_field_floors(inputs)
	if (locale === "fr") return fr_field_floors(inputs)
	if (locale === "de") return de_field_floors(inputs)
	if (locale === "ja") return ja_field_floors(inputs)
	if (locale === "zh") return zh_field_floors(inputs)
	if (locale === "ar") return ar_field_floors(inputs)
	if (locale === "id") return id_field_floors(inputs)
	if (locale === "it") return it_field_floors(inputs)
	if (locale === "ru") return ru_field_floors(inputs)
	if (locale === "pt") return pt_field_floors(inputs)
	return ko_field_floors(inputs)
});